import { request } from 'apis/lib/request_cms';
import { request as request_video } from 'apis/lib/request_video';
import { baseUrlFile } from 'utils/ces/ce_upload';

// 查询列表
export function getList(params) {
    return request({
        url: '/mwebapi/cms/videoLib/findByPagination',
        method: 'get',
        params,
    });
}
// 删除
export function doDeleteVideo(data, logObj) {
    return request({
        url: '/mwebapi/cms/videoLib/deleteById',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '视频库',
            operModule: '删除视频',
        },
    });
}
// 删除
export function doDelete(data, logObj) {
    return request({
        url: '/mwebapi/cms/videoLib/deleteById',
        method: 'post',
        data,
        logObj,
        logFlag: {
            appName: '视频库',
            operModule: '删除视频',
        },
    });
}
// 上传视频
export function upload(data) {
    return request({
        url: '/mwebapi/cms/repository/addVideo',
        method: 'post',
        data,
        timeout: 1000 * 60 * 60,
    });
}
// 上传视频oss
export function uploadCommon(data, params) {
    return request({
        url: '/vedio/common/upload',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        timeout: 1000 * 60 * 60,
    });
}
//转码
export function transcode(data, params) {
    return request({
        url: '/vedio/process/transcode',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
// 获取转码状态
export function getTranscodeResult(params) {
    return request_video({
        url: '/vedio/process/getTranscodeResult',
        method: 'get',
        params,
        baseURL: baseUrlFile().baseURLFile,
    });
}
//截取第一张图
export function snapshot(data, params) {
    return request_video({
        url: '/vedio/process/snapshot',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
// 添加到视频库
export function add(data) {
    return request({
        url: '/mwebapi/cms/videoLib/add',
        method: 'post',
        data,
    });
}
export function addVideo(data) {
    return request({
        url: '/mwebapi/cms/videoLib/add',
        method: 'post',
        data,
    });
}
// 修改
export function update(data, params) {
    return request({
        url: '/mwebapi/cms/videoLib/update',
        method: 'post',
        data,
        params,
    });
}
// 单条删除
export function deleteById(params, logObj) {
    return request({
        url: '/mwebapi/cms/videoLib/deleteById',
        method: 'post',
        params,
        logObj,
        logFlag: {
            appName: '视频库',
            operModule: '删除视频',
        },
    });
}
// 单条删除
export function deleteVideoById(params, logObj) {
    return request({
        url: '/mwebapi/cms/videoLib/deleteById',
        method: 'post',
        params,
        logObj,
        logFlag: {
            appName: '视频库',
            operModule: '删除视频',
        },
    });
}
//详情
export function getVideoDetail(params) {
    return request({
        url: '/mwebapi/cms/videoLib/getById',
        method: 'GET',
        params,
    });
}
// 视频下载
export function getVideo(url) {
    return request({
        url: '/mwebapi/cms/getVideo/' + url,
        method: 'get',
        baseURL: baseUrlFile().recordURL,
        responseType: 'blob',
    });
}

//修改时 清除缓存
export function clearCDNCacheVideo(data, params) {
    return request({
        url: '/vedio/common/clearCdn',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        timeout: 1000 * 60 * 60,
    });
}

// 拷贝视频
export function copyVideo(data, params) {
    return request({
        url: '/vedio/common/copy',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
export function getLimitListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpTenantLimit/getLimitListByTenantId',
        method: 'post',
        data,
        dataType: 'form',
    });
}
//获取容量单位b
export function getCapacity(params) {
    return request({
        url: 'mwebapi/cms/pictureLib/getCapacity',
        method: 'get',
        params,
    });
}
//获取容量单位b
export function getProductGroupCapacity(params) {
    return request({
        url: 'mwebapi/cms/pictureLib/getProductGroupCapacity',
        method: 'get',
        params,
    });
}
//取消上传
export function doCancelUpload(data, params) {
    return request({
        url: '/vedio/common/cancelUpload',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
//分片上传-获取uploadId
export function doGetUploadId(params) {
    return request({
        url: '/vedio/common/getMultipartUploadId',
        method: 'get',
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
//分片上传-获取已上传分片数
export function doGetUploadPic(params) {
    return request({
        url: '/vedio/common/getUploadedMultipart',
        method: 'get',
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
//分片上传-合并文件
export function doMerge(data, params) {
    return request({
        url: '/vedio/common/completeMultipartUpload',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        dataType: 'form',
    });
}
//分片上传-分片上传
export function doUploadPic(data, params) {
    return request({
        url: '/vedio/common/multipartUpload',
        method: 'post',
        data,
        params,
        baseURL: baseUrlFile().baseURLFile,
        timeout: 1000 * 60 * 60,
    });
}
//获取视频播放量
export function counterFind(data) {
    return request({
        url: '/fwebapi/visitor/counter/find',
        method: 'post',
        data,
    });
}
// 获取权限

export function addTempAuthority(data) {
    return request({
        url: '/mwebapi/lowcode/memauthority/addTempAuthority',
        method: 'post',
        data,
    });
}

// 产品级容量限制查询接口
export function getByProductGroupIdAndLimitKey(params) {
    return request({
        url: '/home-service/router/boss/productAppLimit/getByProductGroupIdAndLimitKey',
        method: 'get',
        params,
    });
}
